import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { useArtifactCanvas } from '@/components/artifact/artifact-canvas-context'
import { UserCanvasForm } from '@/components/admin/user-canvas-form'

export function useOpenUserEditCanvas() {
  const { openCanvas, closeCanvas } = useArtifactCanvas()
  const queryClient = useQueryClient()

  return useCallback(
    (userId: string, _userLabel?: string, options?: { platformMode?: boolean }) => {
      openCanvas({
        title: 'Edit user',
        preventAutoFocus: true,
        content: (
          <UserCanvasForm
            key={userId}
            userId={userId}
            platformMode={options?.platformMode}
            onClose={closeCanvas}
            onSuccess={() => {
              void queryClient.invalidateQueries({ queryKey: ['admin-users'] })
              void queryClient.invalidateQueries({ queryKey: ['admin-user', userId] })
              closeCanvas()
            }}
          />
        ),
      })
    },
    [closeCanvas, openCanvas, queryClient],
  )
}
